'use client';

import { log } from "@logtail/next";
import JobCard from "app/components/JobCard";
import StyledSpinner from "app/components/StyledSpinner";
import Link from "next/link";
import { HiArrowRight } from "react-icons/hi";
import useSWR from "swr";
import { getRelatedAnimations } from "./ServerActions";
import { useEffect } from "react";

type RelatedAnimationsProps = {
    userId: string,
    excludeJobId?: string
}

export default function RelatedAnimations({ userId, excludeJobId }: RelatedAnimationsProps) {

    const fetcher = async ({ excludeJobId }: { userId: string, excludeJobId: string }) => {
        return await getRelatedAnimations(userId, excludeJobId);
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { data, error, isLoading } = useSWR({ userId, excludeJobId }, fetcher, { refreshInterval: 10000, keepPreviousData: true });

    if (error) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        log.error(`Failed to fetch related animations`, { error });
    }

    useEffect(() => {
        if (data && data.length > 0) {
            log.info(`Recent animations fetched successfully`, { data });
        }
    }, [data]);

    return (<>
        <div className="flex flex-col lg:flex-row gap-y-6 gap-x-2 mt-6 items-center lg:justify-center flex-wrap">
            {
                (data && data.length > 0)
                    ? data.map((d) => <JobCard key={d.id} displayData={d} showArtist={false} showTitle={true} showStatus={true} liveUpdate={true} showCreateDate={true} className='my-2' />)
                    : isLoading
                        ? "Loading..."
                        : <>Nothing to show yet. Create away!</>
            }
            {
                isLoading && <StyledSpinner />
            }
        </div>
        {
            (data && data.length > 0)
                ? <div className="flex w-full justify-end pt-12"><Link href='/library'>See all your animations <HiArrowRight className="inline ml-1" /></Link> </div>
                : <></>
        }

    </>
    )

}